import { render } from "./ErrorPanel.vue?vue&type=template&id=462fe1f3&scoped=true"
import script from "./ErrorPanel.vue?vue&type=script&lang=js"
export * from "./ErrorPanel.vue?vue&type=script&lang=js"

import "./ErrorPanel.vue?vue&type=style&index=0&id=462fe1f3&scoped=true&lang=less"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462fe1f3"],['__file',"backend/vue/components/ErrorPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "462fe1f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('462fe1f3', __exports__)) {
    api.reload('462fe1f3', __exports__)
  }
  
  module.hot.accept("./ErrorPanel.vue?vue&type=template&id=462fe1f3&scoped=true", () => {
    api.rerender('462fe1f3', render)
  })

}


export default __exports__